import React from 'react';
import styled from 'styled-components';
import { Wrapper } from '../shared/commonStyles';
import Title from '../title/Title';
import Description from '../text/Description';
import ProductCard from '../card/ProductCard';

import Image1 from '../../assets/image/collaboration_dress/anteprima.png'
import Image2 from '../../assets/image/collaboration_dress/lulufelice.png'
import Image3 from '../../assets/image/collaboration_dress/isamumorita.png'
import Image4 from '../../assets/image/collaboration_dress/serina_farny.png'
import Image5 from '../../assets/image/collaboration_dress/onepiece.png'

const CollaborationDressWrapper = styled.section`
  
`;

const SectionCollaborationDress = () => {
    const text = 'PLACOLE＆DRESSY(プラコレ＆ドレシー)は\nこれまでに、人気アニメや様々なドレスブランドと\nコラボレーションをし\nオリジナルドレスを発表してきました。';
    const buttonText = '記事を読む'

    const items =[
        {title: "ANTEPRIMA（アンテプリマ）", image: Image1, url: "https://dressy.pla-cole.wedding/anteprima-23nd-weddingdress/"},
        {title: "Lulu felice（ルルフェリーチェ）", image: Image2, url: "https://dressy.pla-cole.wedding/lulu-felice-placole%ef%bc%86dressy/"},
        {title: "ISAMU MORITA（イサムモリタ）", image: Image3, url: "https://dressy.pla-cole.wedding/isamumorita-dressy-by-placole/"},
        {title: "SERINA（セリナ）×「美花嫁嫁図鑑 farny」", image: Image4, url: "https://dressy.pla-cole.wedding/serina-farny/"},
        {title: "アニメ「ONE PIECE（ワンピース）」", image: Image5, url: "https://dressy.pla-cole.wedding/release-onepiecedress/"},
    ]

    return (
      <Wrapper id="collaboration-dress">
        <CollaborationDressWrapper>
            <Title 
                title={"COLLABORATION DRESS"}
                subTitle={"コラボドレス"}    
            />
            <Description text={text} />
            {items.map((item, index) => (
                <ProductCard 
                    key={index}
                    title={item.title}
                    image={item.image}
                    url={item.url}
                    buttonText={buttonText}
                />
            ))}
            
        </CollaborationDressWrapper>
      </Wrapper>
    );
  };
  
export default SectionCollaborationDress;
  